import register from '../../../../global/js/registry';
export default register('m-formstep-main-part-component', () => import(/* webpackMode: "lazy" */ './m-formstep-main-part-component.controller'));
